<template>
    <div class="main-login">
        <v-row class="justify-center align-center no-gutters">
            <v-col cols="12" lg="4" md="5" sm="6" xl="3">
                <div class="form-login">
                    <v-img src="images/logo.svg" width="166"/>

                    <h1 class="mb-6">{{ $t("login.reset_password") }}</h1>

                    <v-form v-model="valid">

                        <v-text-field
                            v-model="login"
                            :label="$t('login.email_address')"
                            dense
                            outlined
                            type="text"
                        ></v-text-field>

                        <v-text-field
                            v-model="password"
                            :label="$t('login.password_new')"
                            :rules="passwordRules"
                            dense
                            outlined
                            type="password"
                        ></v-text-field>

                        <v-text-field
                            v-model="passwordConfirm"
                            :label="$t('login.password_confirm')"
                            :rules="passwordConfirmRules"
                            dense
                            outlined
                            type="password"
                        ></v-text-field>

                        <div class="d-flex">
                            <v-btn :disabled="!valid" :loading="loading" block
                                   color="primary"
                                   elevation="0"
                                   @click="handleClick">
                                {{ $t("global.validate") }}
                            </v-btn>
                        </div>
                    </v-form>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {showSnackbar} from "../functions";

export default {
    name: "ResetPassword",
    data() {
        return {
            login: null,
            loginRules: [(v) => !!v || this.$t("login.required_login")],
            passwordRules: [(v) => !!v || this.$t("login.required_login")],
            passwordConfirmRules: [(v) => !!v && v === this.password || this.$t("login.required_login")],
            valid: false,
            loading: false,
            token: null,
            password: null,
            passwordConfirm: null,
        };
    },
    mounted() {
        this.token = this.$route.query.token
    },
    methods: {
        async handleClick() {
            try {
                this.loading = true

                await this.$api.auth.resetPassword({
                    identifier: this.login,
                    password: this.password,
                    token: this.token
                })

                showSnackbar("success", this.$t('login.password_updated'))

                this.$router.push({name: "login"})
            } catch (e) {
            } finally {
                this.loading = false
            }
        }
    }
};
</script>
